export default "__VITE_ASSET__BvRfi7$D__"